import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.overlayDarkHeavy,
  bottom: '0',
  color: theme.color.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
});

const OverlayWrapper = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

OverlayWrapper.propTypes = {
  children: PropTypes.node,
};

export default React.memo(OverlayWrapper);
